import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, ErrorHandler } from '@angular/core';

import { AppComponent } from './app.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

/*import { AlertModule, CollapseModule, PaginationModule, BsDropdownModule, PopoverModule, CarouselModule, ButtonsModule } from 'ngx-bootstrap';*/
import { AlertModule } from 'ngx-bootstrap/alert';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { ButtonsModule } from 'ngx-bootstrap/buttons';

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

import { MatDialogModule } from '@angular/material/dialog';

import { MatDatepickerModule } from '@angular/material/datepicker';

import { MatCheckboxModule } from '@angular/material/checkbox';

import { MatFormFieldModule } from '@angular/material/form-field';

import { MatNativeDateModule } from '@angular/material/core';

import { MatInputModule } from '@angular/material/input';

import { ReCaptchaModule } from 'angular2-recaptcha';

import { ResourceModule } from '@ngx-resource/handler-ngx-http';

import { NgxWebstorageModule } from 'ngx-webstorage';

import { CookieModule } from 'ngx-cookie';

import { NouisliderModule } from 'ng2-nouislider';

// Directives

import { EqualValidatorDirective } from './commons/equal-validator.directive';
import { PasswordValidatorDirective } from './commons/password-validator.directive';
import { EmailValidatorDirective } from './commons/email-validator.directive';


// Services

import { OAuthService } from './services/oauth.service';
import { UserService } from './services/user.service';
import { SubscriptionsService } from './services/subscriptions.service';
import { DashboardService } from './services/dashboard.service';
import { HeaderService } from './services/header.service';
import { BlogService } from './services/blog.service';
import { FormService } from './services/forms.service';
import { ModuleService } from './services/modules.service';
import { CustomPageService } from './services/custom-page.service';
import { GlobalErrorHandler } from './services/errorHandler.service';
import { GlobalFlagsService } from './services/global-flags.service';
import { StorageService } from './services/storage.service';
import { RegistrationService } from './services/registration.service';
import { DialogService } from './services/dialog.service';
import { AdminRedirectService } from './services/admin-redirect.service';
import { LocationService } from './services/location.service';
import { ContactService } from './services/contact.service';
import { RequestHistoryService } from './services/requestHistory.service';

// Pipes

import { SafeHtmlPipe } from './pipes/SafeHtmlPipe';

// Guards
import { CanActivateViaOAuthGuard } from './guards/oAuth.canActivateGuard';
import { LoggedInGuard } from './guards/logged-inGuard.module';
import { FormDeactivateGuard } from './guards/form.deactivate';
import { RegistrationDeactivateGuard } from './guards/registration.deactivate';

// Routing
import { AppRoutingModule } from './commons/app-routing.module';

// Components
import { LoginComponent } from './views/login/login.component';
import { MfaComponent } from './views/mfa/mfa.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { ExternalLinksComponent } from './views/external-links/external-links.component';
import { HeaderComponent } from './views/header/header.component';
import { IoNewsComponent } from './views/io-news/io-news.component';
import { IoBlogComponent } from './views/io-blog/io-blog.component';
import { FormsComponent } from './views/forms/forms.component';
import { RadioButtonComponent } from './views/forms/components/radio-button/radio-button.component';
import { BodyComponent } from './views/forms/components/body/body.component';
import { ComboboxComponent } from './views/forms/components/combobox/combobox.component';
import { CheckboxTableComponent } from './views/forms/components/checkbox-table/checkbox-table.component';
import { CheckboxFragmentComponent } from './views/forms/components/checkbox-fragment/checkbox-fragment.component';
import { TextboxComponent } from './views/forms/components/textbox/textbox.component';
import { RadioButtonTableComponent } from './views/forms/components/radio-button-table/radio-button-table.component';
import { LabelComponent } from './views/forms/components/label/label.component';
import { HelpLineComponent } from './views/custom-pages/help-line/help-line.component';
import { LocalResourcesComponent } from './views/custom-pages/local-resources/local-resources.component';
import { LearnAboutIoComponent } from './views/custom-pages/learn-about-io/learn-about-io.component';
import { ErrorComponent } from './views/error/error.component';
import { LandingComponent } from './views/public/landing/landing.component';
import { ContactUsComponent } from './views/public/contact-us/contact-us.component';
import { ForgotPasswordComponent } from './views/public/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './views/public/reset-password/reset-password.component';
import { DatetimeComponent } from './views/forms/components/datetime/datetime.component';
import { CustomPageComponent } from './views/public/custom-page/custom-page.component';
import { BlogsListComponent } from './views/blogs-list/blogs-list.component';
import { WizardComponentRegister } from './views/wizard/wizard.component';
import { StartSurveyComponent } from './views/start-survey/start-survey.component';
import { DownloadReportComponent } from './views/download-report/download-report.component';
import { EditUserComponent } from './views/user/edit/edit.component';
import { UserFormComponent } from './views/user/user-form/user-form.component';
import { SubscriptionsComponent } from './views/user/subscriptions/subscriptions.component';
import { FooterComponent } from './views/footer/footer.component';
import { DialogComponent } from './views/commons/dialog/dialog.component';
import { DialogHistoryComponent } from './views/commons/dialog-history-table/dialog-history-table.component';
import { Audioplayer } from './views/commons/audioplayer/audioplayer.component';
import { DialogLoginHospital } from './views/commons/dialog-login-hospital/dialog-login-hospital.component';
import { DialogChangePassword } from './views/commons/dialog-change-password/dialog-change-password.component';
import { ContinueWithSSOComponent } from './views/public/continue-with-sso/continue-with-sso.component';

// Thumbnails
import { ThumbnailLearnAboutIoComponent } from './views/thumbnails/learn-about-io/thumb-learn-about-io.component';
import { ThumbnailLivingWithCancerComponent } from './views/thumbnails/living-with-cancer/thumb-living-with-cancer.component';
import { ThumbnailJoinTodayComponent } from './views/thumbnails/join-today/thumb-join-today.component';

// test translate JSON
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';


// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
    // for development
    // return new TranslateHttpLoader(http, '/start-angular/SB-Admin-BS4-Angular-5/master/dist/assets/i18n/', '.json');
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        AppComponent,
        EqualValidatorDirective,
        PasswordValidatorDirective,
        EmailValidatorDirective,
        SafeHtmlPipe,
        LoginComponent,
        MfaComponent,
        DownloadReportComponent,
        DashboardComponent,
        HeaderComponent,
        IoNewsComponent,
        ExternalLinksComponent,
        IoBlogComponent,
        FormsComponent,
        RadioButtonComponent,
        BodyComponent,
        ComboboxComponent,
        CheckboxTableComponent,
        CheckboxFragmentComponent,
        TextboxComponent,
        RadioButtonTableComponent,
        LabelComponent,
        HelpLineComponent,
        LocalResourcesComponent,
        ErrorComponent,
        LandingComponent,
        ContactUsComponent,
        DatetimeComponent,
        CustomPageComponent,
        BlogsListComponent,
        WizardComponentRegister,
        StartSurveyComponent,
        EditUserComponent,
        UserFormComponent,
        SubscriptionsComponent,
        LearnAboutIoComponent,
        FooterComponent,
        DialogComponent,
        DialogHistoryComponent,
        DialogLoginHospital,
        ThumbnailLearnAboutIoComponent,
        ThumbnailLivingWithCancerComponent,
        ThumbnailJoinTodayComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        Audioplayer,
        DialogChangePassword,
        ContinueWithSSOComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CollapseModule.forRoot(),
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        NgIdleKeepaliveModule.forRoot(),
        AlertModule.forRoot(),
        PaginationModule.forRoot(),
        PopoverModule.forRoot(),
        BsDropdownModule.forRoot(),
        ButtonsModule.forRoot(),
        CarouselModule.forRoot(),
        ResourceModule.forRoot(),
        NgxWebstorageModule.forRoot(),
        CookieModule.forRoot(),
        MatDialogModule,
        ReCaptchaModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        MatInputModule,
        MatCheckboxModule,
        MatFormFieldModule,
        NouisliderModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        })
    ],
    providers: [
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        OAuthService,
        UserService,
        SubscriptionsService,
        ContactService,
        DashboardService,
        HeaderService,
        BlogService,
        FormService,
        ModuleService,
        StorageService,
        CustomPageService,
        RequestHistoryService,
        RegistrationService,
        RegistrationDeactivateGuard,
        LocationService,
        GlobalFlagsService,
        DialogService,
        AdminRedirectService,
        CanActivateViaOAuthGuard,
        FormDeactivateGuard,
        LoggedInGuard
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
